import { createContext, useContext } from "react";

const ProjectContext = createContext({});

export const ProjectContextProvider = ProjectContext.Provider;
export const ProjectContextConsumer = ProjectContext.Consumer;

export const useProjectContext = () => useContext(ProjectContext);

export default ProjectContext;
